import { InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'
import React from 'react'

import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import useStyles from './styles/index.styles'

interface TicketSearchInputProps {
  value: string
  onChange: (value: string) => void
}

/**
 * The single-text-search filter pattern (portal conventions §3): a full-width
 * `InputWithLabel` with a search `startIcon`, filtering client-side.
 *
 * Shared by both ticket lists rather than duplicated, because the caveat below
 * is the kind of thing that gets fixed in one copy and not the other.
 *
 * The caveat: the list is cursor-paginated and the server takes no filter
 * argument, so this searches the pages loaded so far. Left unsaid, an operator
 * who searches, sees nothing, and concludes the ticket does not exist would be
 * wrong — so when pages remain, say so and say how many are being searched.
 */
export default function TicketSearchInput({
  value,
  onChange
}: TicketSearchInputProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <InputWithLabel
        data-cy="ticketSearchInput"
        placeholder={getTranslate('Search by number, title, product or code')}
        autoComplete="off"
        noHelperText
        fullWidth
        inputSize="small"
        startIcon={<SearchIcon />}
        className={classes.searchInput}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(
            convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
          )
        }
      />
    </div>
  )
}
